export const getVideoId = (url = '') => {
  const result = url.match(
    /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  if (result && result.length > 1) {
    return result[1];
  }
  return '';
};

export const getPreviewImage = url => `https://img.youtube.com/vi/${getVideoId(url)}/0.jpg`;
